export default __webpack_public_path__ + "static/media/quadradoVermelho.b943c105.png";